module.exports = __webpack_public_path__ + "2UX7WLTfW3W8TclTUvlFyQ.16e1d930cf13fb7a9563.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto/2UX7WLTfW3W8TclTUvlFyQ.woff
// module id = 780
// module chunks = 1